import React from 'react';
import { MailIcon, InstagramIcon, DumbbellIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-carbon py-12" data-id="element-122">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-123">
        <p className="flex items-center justify-center gap-2.5 font-heading text-xl font-extrabold uppercase tracking-[0.18em] text-soft" data-id="element-124">
          <DumbbellIcon className="h-5 w-5 text-gold" data-id="element-125" />
          Cherub{' '}
          <span className="bg-gradient-to-r from-gold via-[#E6C766] to-gold bg-clip-text text-transparent" data-id="element-126">
            Agency
          </span>
          <span className="align-super text-[0.6em] text-gold" data-id="element-127">®</span>
        </p>
        <p className="mt-2 text-sm text-muted" data-id="element-128">
          Rendimiento deportivo real para el mundo real.
        </p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted" data-id="element-129">
          <a href="mailto:soporte@cherubagency.com" className="flex items-center gap-2 transition-colors hover:text-orange" data-id="element-130">
            <MailIcon className="h-4 w-4" data-id="element-131" /> soporte@cherubagency.com
          </a>
          <span className="flex items-center gap-2" data-id="element-132">
            <InstagramIcon className="h-4 w-4" data-id="element-133" /> @cherubagency
          </span>
        </div>
        <p className="mt-8 text-xs text-muted" data-id="element-134">
          © Cherub Agency® 2026 — Todos los derechos reservados. Prohibida la
          reproducción sin autorización expresa.
        </p>
      </div>
    </footer>;
}